import { CREATEPROJECT_SUCCESS, CREATEPROJECT_FAIL } from "../actionTypes";

const initialState = {
    user: null,
};

const createProjectReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATEPROJECT_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload,
            };
        case CREATEPROJECT_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default createProjectReducer;
